import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {handleInvalidToken, refreshSession, TOKEN_LOCAL_STORAGE_KEY} from "./asyncActions";
import {User} from "../../../api/UserService";

export enum SessionState {
    LOADING,
    REGISTERING_RESETTING,
    NO_PROFILE,
    INACTIVE,
    ACTIVE
}

interface State {
    sessionState: SessionState
    loading: boolean,
    isHandicaddieUser: boolean
    user?: User
    token?: string
    userAvatar?: string
}

const initialState: State = {
    sessionState: SessionState.LOADING,
    loading: false,
    isHandicaddieUser: false
};

export interface RefreshSessionActionPayload {
    sessionState?: SessionState
    token?: string
    user?: User
}

let currentUserSlice = createSlice(
    {
        name: "CurrentUser",
        initialState: initialState,
        reducers: {
            handleLogin: (state, action: PayloadAction<string>) => {
                localStorage.setItem(TOKEN_LOCAL_STORAGE_KEY, action.payload)
                state.token = action.payload;
            },
            handleLogOut: (state) => {
                localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY)
                state.sessionState = SessionState.INACTIVE;
                state.user = undefined;
                state.token = undefined;
            },
            handleRegisterSuccess: (state, action: PayloadAction<string>) => {
                localStorage.setItem(TOKEN_LOCAL_STORAGE_KEY, action.payload)
                state.token = action.payload;
            },
            handleUserCreated: (state, action: PayloadAction<User>) => {
                state.sessionState = SessionState.ACTIVE;
                state.user = action.payload;
            },
            handleEnteringRegisteringOrResetting: (state) => {
                state.sessionState = SessionState.REGISTERING_RESETTING;
            },
        },
        extraReducers: (builder) => {
            builder
                .addCase(refreshSession.pending, (state) => {
                    state.loading = true
                })
                .addCase(refreshSession.fulfilled, (state, action: PayloadAction<RefreshSessionActionPayload>) => {
                    if (action.payload.sessionState) {
                        state.sessionState = action.payload.sessionState
                    }
                    if (action.payload.token) {
                        state.token = action.payload.token
                    }
                    if (action.payload.user) {
                        state.user = action.payload.user
                        state.isHandicaddieUser = action.payload.user.email.endsWith('@handicaddie.com')
                    }
                    state.loading = false
                })
                .addCase(
                    handleInvalidToken.fulfilled,
                    (state, action: PayloadAction<SessionState>) => {
                        state.sessionState = action.payload
                    }
                )
        }
    }
);

export const {
    handleLogOut,
    handleRegisterSuccess,
    handleUserCreated,
    handleLogin,
    handleEnteringRegisteringOrResetting,
} = currentUserSlice.actions;

export default currentUserSlice.reducer;